// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PaperSelector-cls1___2207e112bb2b7e776d8{/*!*/}.PaperSelector-cls2___cdc0d4a162789f248fa{color:#0645b1;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "PaperSelector-cls1___2207e112bb2b7e776d8",
	"cls2": "PaperSelector-cls2___cdc0d4a162789f248fa PaperSelector-cls1___2207e112bb2b7e776d8"
};
export default ___CSS_LOADER_EXPORT___;
